import React, { useEffect, useState } from "react";
import PensionPage from "../../entities/PensionPage";
import AuthService from "../../api/AuthService";
import LoaderHelper from "../../utils/Loader/LoaderHelper";
import { useAlert } from "../../context/AlertContext";

const Pensionfild = () => {
  const [pension, setPension] = useState([]);
  const [loading, setLoading] = useState(false);

  const { showAlert } = useAlert();

  useEffect(() => {
    getPension();
  }, []);
  const getPension = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAdmPension();
      if (result?.success) {
        setPension(result?.data?.fringes);

        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
        // console.log(result?.message, "kjshakjh");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };
  const handlePension = async (name, tax, id) => {
    setLoading(true);
    try {
      const result = await AuthService.handleSupPension(name, tax, id);
      if (result?.success === true) {
        getPension();
        setLoading(false);
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error?.message, "error");
    }
  };


  const handleDeletePension = async (id) => {
    setLoading(true);
    try {
      const result = await AuthService.deleteSupPension(id);
      if (result?.success === true) {
        getPension();
        setLoading(false);
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error?.message, "error");
    }
  };
  const handleCreatePension = async (leave, isPaid) => {
    setLoading(true);
    try {
      const result = await AuthService.createPansion(leave, isPaid);
      if (result?.success === true) {
        getPension();
        setLoading(false);
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error?.message, "error");
    }
  };
  return (
    <>
      <PensionPage
        pensions={pension}
        handlePension={handlePension}
        handleDeletePension={handleDeletePension}
        loading={loading}
        handleCreatePension={handleCreatePension}
      />
    </>
  );
};

export default Pensionfild;
